import { InputTextarea } from "primereact/inputtextarea";

// multi line text, same look as genElText
const FieldTextarea = ({ field, name, data, setData, disabled, error = {} }) => {
  return (
    <div className="col-start-start w-100 gap-1">
      <label htmlFor={field} className="font-bold text-sm text-slate-500">
        {name}
      </label>
      <InputTextarea
        id={field}
        className={`w-full ${error[field] ? "bg-red-100" : ""}`}
        rows={3}
        autoResize
        disabled={disabled}
        value={data[field] ?? ""}
        onChange={(e) => setData({ ...data, [field]: e.target.value })}
      />
      {error[field] && (
        <small className="font-semibold text-red-400">{error[field]}</small>
      )}
    </div>
  );
};

export default FieldTextarea;
